import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Services = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-hero">
        <div className="breadcrumb-overlay"></div>
        <div className="breadcrumb-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="breadcrumb-title">
                  <span className="breadcrumb-highlight">Our Services</span>
                </h1>
                <p className="breadcrumb-description" style={{ color: '#bdbbbbff' }}>Profit Technologies delivers bespoke software solutions tailored to your business needs - your trusted software development partner.</p>
                <Link to="/contact" style={{ textDecoration: 'none' }}>
                  <button className="breadcrumb-btn">
                    <span>CONNECT NOW</span>
                    <span className="breadcrumb-arrow">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="breadcrumb-pattern"></div>
      </section>

      <section className="services-list-section py-5">
        <div className="container">
          <h2 className="intro-about-heading" style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span className="text-gradient">Our Services</span>
          </h2>

          <div className="row g-4">
            {/* Service 1 - App Development */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/app-development" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80" alt="App Development" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">App Development</h3>
                    <p className="service-item-desc-new">
                      Transform Ideas Into Powerful Apps. Bring your vision to life with innovative mobile solutions that engage users and drive business growth. From concept to launch, we craft apps that make an impact.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Service 2 - Website Development */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/website-development" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80" alt="Website Development" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">Website Development</h3>
                    <p className="service-item-desc-new">
                      Elevate Your Digital Presence. Transform your brand with cutting-edge web design that combines stunning aesthetics with powerful functionality and delivers exceptional user experiences.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Service 3 - Software Development */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/software-development" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80" alt="Software Development" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">Software Development</h3>
                    <p className="service-item-desc-new">
                      Transform Your Business. Partner with expert software engineers to create scalable, robust, and innovative software solutions. From enterprise applications to SaaS platforms, we bring your vision to life.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Service 4 - Digital Marketing */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/digital-marketing" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" alt="Digital Marketing" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">Digital Marketing</h3>
                    <p className="service-item-desc-new">
                      Accelerate Your Growth. Drive measurable results with data-driven marketing strategies that amplify your brand, engage your audience, and boost your ROI across all digital channels.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Service 5 - IT Consulting */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/it-consulting" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80" alt="IT Consulting" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">IT Consulting</h3>
                    <p className="service-item-desc-new">
                      Strategic Technology Advisory. Empower your organization with expert technology guidance that drives innovation, optimizes operations, and ensures sustainable growth with digital transformation.
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Service 6 - Startup Consulting */}
            <div className="col-lg-6 col-md-6">
              <Link to="/services/startup-consulting" style={{ textDecoration: 'none' }}>
                <div className="service-item-card-new">
                  <div className="service-item-image-new">
                    <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80" alt="Startup Consulting" />
                  </div>
                  <div className="service-item-content-new">
                    <h3 className="service-item-title-new">Startup Consulting</h3>
                    <p className="service-item-desc-new">
                      Launch & Scale Your Startup. Transform your vision into reality with comprehensive startup consulting covering everything from MVP development to market launch and scaling strategies.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
